// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

    --pink: #f2c4c4;
    --peach: #f9e1be;
    --mint: #bff1db;
    --lavender: #d5d1fd;

}

/* ---------------- PAGE ---------------- */

.notfound-page {

    height: 100vh;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    background: #fff;

    position: relative;

    overflow: hidden;

}

/* ---------------- BLOBS ---------------- */

.blob {

    position: absolute;

    border-radius: 50%;

    opacity: .5;

    filter: blur(6px);

    animation: blobFloat 8s ease-in-out infinite;

}

.blob1 {

    width: 320px;
    height: 320px;

    background: var(--lavender);

    top: -120px;
    left: -100px;

}

.blob2 {

    width: 250px;
    height: 250px;

    background: var(--mint);

    bottom: -70px;
    right: -80px;

    animation-delay: 2s;

}

.blob3 {

    width: 170px;
    height: 170px;

    background: var(--peach);

    top: 120px;
    right: 80px;

    animation-delay: 4s;

}

@keyframes blobFloat {

    0%,
    100% {

        transform: translateY(0);

    }

    50% {

        transform: translateY(-18px);

    }

}

/* ---------------- CARD ---------------- */

.notfound-card {

    width: 520px;

    background: white;

    padding: 55px;

    border-radius: 30px;

    text-align: center;

    position: relative;

    z-index: 5;

    box-shadow:

        0 25px 70px rgba(0, 0, 0, .08),

        0 0 0 1px rgba(213, 209, 253, .18);

}

/* ---------------- ILLUSTRATION ---------------- */

.illustration {

    width: 190px;
    height: 190px;

    margin: auto;

    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

}

.marker {

    width: 100px;
    height: 100px;

    border-radius: 50%;

    background: white;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 44px;

    color: #6b63d9;

    position: relative;

    z-index: 2;

    box-shadow:

        0 15px 35px rgba(213, 209, 253, .45);

    animation: bounce 3s ease-in-out infinite;

}

.orbit {

    position: absolute;

    border-radius: 50%;

    border: 2px dashed rgba(213, 209, 253, .8);

}

.orbit1 {

    width: 130px;
    height: 130px;

    animation: spin 12s linear infinite;

}

.orbit2 {

    width: 180px;
    height: 180px;

    animation: spinReverse 16s linear infinite;

}

.orbit::before {

    content: "";

    position: absolute;

    width: 12px;
    height: 12px;

    border-radius: 50%;

    background: var(--mint);

    top: -6px;
    left: 50%;

    transform: translateX(-50%);

    box-shadow: 0 0 10px rgba(191, 241, 219, .7);

}

/* ---------------- TEXT ---------------- */

.error-number {

    font-size: 72px;

    font-weight: 800;

    letter-spacing: 4px;

    margin-top: 10px;

    margin-bottom: 10px;

    color: #6b63d9;

}

.notfound-card h1 {

    font-size: 34px;

    font-weight: 700;

    color: #394150;

    margin-bottom: 18px;

}

.notfound-card p {

    line-height: 1.8;

    color: #667085;

    margin-bottom: 35px;

}

/* ---------------- BUTTONS ---------------- */

.button-row {

    display: flex;
    justify-content: center;
    gap: 18px;

}

.action-btn {

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    padding: 12px 24px;

    font-weight: 600;

    border-radius: 14px;

    transition: .25s;

}

.home-btn {

    background: var(--lavender);

    border: none;

}

.home-btn:hover {

    background: #c7c3fc;

    transform: translateY(-2px);

}

.btn-light {

    border: 1px solid #ddd;

}

.btn-light:hover {

    background: #fafafa;

    transform: translateY(-2px);

}

/* ---------------- ANIMATIONS ---------------- */

@keyframes spin {

    from {

        transform: rotate(0deg);

    }

    to {

        transform: rotate(360deg);

    }

}

@keyframes spinReverse {

    from {

        transform: rotate(360deg);

    }

    to {

        transform: rotate(0deg);

    }

}

@keyframes bounce {

    0%,
    100% {

        transform: translateY(0);

    }

    50% {

        transform: translateY(-10px);

    }

}

/* ---------------- MOBILE ---------------- */

@media(max-width:768px) {

    .notfound-card {

        width: 90%;

        padding: 40px 28px;

    }

    .error-number {

        font-size: 56px;

    }

    .button-row {

        flex-direction: column;

    }

}`, "",{"version":3,"sources":["webpack://./src/screens/NotFound.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;;AAEvB;;AAEA,2CAA2C;;AAE3C;;IAEI,aAAa;IACb,WAAW;;IAEX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,kBAAkB;;IAElB,gBAAgB;;AAEpB;;AAEA,4CAA4C;;AAE5C;;IAEI,kBAAkB;;IAElB,kBAAkB;;IAElB,WAAW;;IAEX,iBAAiB;;IAEjB,4CAA4C;;AAEhD;;AAEA;;IAEI,YAAY;IACZ,aAAa;;IAEb,2BAA2B;;IAE3B,WAAW;IACX,YAAY;;AAEhB;;AAEA;;IAEI,YAAY;IACZ,aAAa;;IAEb,uBAAuB;;IAEvB,aAAa;IACb,YAAY;;IAEZ,mBAAmB;;AAEvB;;AAEA;;IAEI,YAAY;IACZ,aAAa;;IAEb,wBAAwB;;IAExB,UAAU;IACV,WAAW;;IAEX,mBAAmB;;AAEvB;;AAEA;;IAEI;;;QAGI,wBAAwB;;IAE5B;;IAEA;;QAEI,4BAA4B;;IAEhC;;AAEJ;;AAEA,2CAA2C;;AAE3C;;IAEI,YAAY;;IAEZ,iBAAiB;;IAEjB,aAAa;;IAEb,mBAAmB;;IAEnB,kBAAkB;;IAElB,kBAAkB;;IAElB,UAAU;;IAEV;;;;0CAIsC;;AAE1C;;AAEA,mDAAmD;;AAEnD;;IAEI,YAAY;IACZ,aAAa;;IAEb,YAAY;;IAEZ,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;;IAEI,YAAY;IACZ,aAAa;;IAEb,kBAAkB;;IAElB,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;;IAEf,cAAc;;IAEd,kBAAkB;;IAElB,UAAU;;IAEV;;4CAEwC;;IAExC,yCAAyC;;AAE7C;;AAEA;;IAEI,kBAAkB;;IAElB,kBAAkB;;IAElB,0CAA0C;;AAE9C;;AAEA;;IAEI,YAAY;IACZ,aAAa;;IAEb,mCAAmC;;AAEvC;;AAEA;;IAEI,YAAY;IACZ,aAAa;;IAEb,0CAA0C;;AAE9C;;AAEA;;IAEI,WAAW;;IAEX,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,uBAAuB;;IAEvB,SAAS;IACT,SAAS;;IAET,2BAA2B;;IAE3B,4CAA4C;;AAEhD;;AAEA,2CAA2C;;AAE3C;;IAEI,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,cAAc;;AAElB;;AAEA;;IAEI,eAAe;;IAEf,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;;AAEvB;;AAEA;;IAEI,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;;AAEvB;;AAEA,8CAA8C;;AAE9C;;IAEI,aAAa;IACb,uBAAuB;IACvB,SAAS;;AAEb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET,kBAAkB;;IAElB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,gBAAgB;;AAEpB;;AAEA;;IAEI,2BAA2B;;IAE3B,YAAY;;AAEhB;;AAEA;;IAEI,mBAAmB;;IAEnB,2BAA2B;;AAE/B;;AAEA;;IAEI,sBAAsB;;AAE1B;;AAEA;;IAEI,mBAAmB;;IAEnB,2BAA2B;;AAE/B;;AAEA,iDAAiD;;AAEjD;;IAEI;;QAEI,uBAAuB;;IAE3B;;IAEA;;QAEI,yBAAyB;;IAE7B;;AAEJ;;AAEA;;IAEI;;QAEI,yBAAyB;;IAE7B;;IAEA;;QAEI,uBAAuB;;IAE3B;;AAEJ;;AAEA;;IAEI;;;QAGI,wBAAwB;;IAE5B;;IAEA;;QAEI,4BAA4B;;IAEhC;;AAEJ;;AAEA,6CAA6C;;AAE7C;;IAEI;;QAEI,UAAU;;QAEV,kBAAkB;;IAEtB;;IAEA;;QAEI,eAAe;;IAEnB;;IAEA;;QAEI,sBAAsB;;IAE1B;;AAEJ","sourcesContent":[":root {\n\n    --pink: #f2c4c4;\n    --peach: #f9e1be;\n    --mint: #bff1db;\n    --lavender: #d5d1fd;\n\n}\n\n/* ---------------- PAGE ---------------- */\n\n.notfound-page {\n\n    height: 100vh;\n    width: 100%;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background: #fff;\n\n    position: relative;\n\n    overflow: hidden;\n\n}\n\n/* ---------------- BLOBS ---------------- */\n\n.blob {\n\n    position: absolute;\n\n    border-radius: 50%;\n\n    opacity: .5;\n\n    filter: blur(6px);\n\n    animation: blobFloat 8s ease-in-out infinite;\n\n}\n\n.blob1 {\n\n    width: 320px;\n    height: 320px;\n\n    background: var(--lavender);\n\n    top: -120px;\n    left: -100px;\n\n}\n\n.blob2 {\n\n    width: 250px;\n    height: 250px;\n\n    background: var(--mint);\n\n    bottom: -70px;\n    right: -80px;\n\n    animation-delay: 2s;\n\n}\n\n.blob3 {\n\n    width: 170px;\n    height: 170px;\n\n    background: var(--peach);\n\n    top: 120px;\n    right: 80px;\n\n    animation-delay: 4s;\n\n}\n\n@keyframes blobFloat {\n\n    0%,\n    100% {\n\n        transform: translateY(0);\n\n    }\n\n    50% {\n\n        transform: translateY(-18px);\n\n    }\n\n}\n\n/* ---------------- CARD ---------------- */\n\n.notfound-card {\n\n    width: 520px;\n\n    background: white;\n\n    padding: 55px;\n\n    border-radius: 30px;\n\n    text-align: center;\n\n    position: relative;\n\n    z-index: 5;\n\n    box-shadow:\n\n        0 25px 70px rgba(0, 0, 0, .08),\n\n        0 0 0 1px rgba(213, 209, 253, .18);\n\n}\n\n/* ---------------- ILLUSTRATION ---------------- */\n\n.illustration {\n\n    width: 190px;\n    height: 190px;\n\n    margin: auto;\n\n    position: relative;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.marker {\n\n    width: 100px;\n    height: 100px;\n\n    border-radius: 50%;\n\n    background: white;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-size: 44px;\n\n    color: #6b63d9;\n\n    position: relative;\n\n    z-index: 2;\n\n    box-shadow:\n\n        0 15px 35px rgba(213, 209, 253, .45);\n\n    animation: bounce 3s ease-in-out infinite;\n\n}\n\n.orbit {\n\n    position: absolute;\n\n    border-radius: 50%;\n\n    border: 2px dashed rgba(213, 209, 253, .8);\n\n}\n\n.orbit1 {\n\n    width: 130px;\n    height: 130px;\n\n    animation: spin 12s linear infinite;\n\n}\n\n.orbit2 {\n\n    width: 180px;\n    height: 180px;\n\n    animation: spinReverse 16s linear infinite;\n\n}\n\n.orbit::before {\n\n    content: \"\";\n\n    position: absolute;\n\n    width: 12px;\n    height: 12px;\n\n    border-radius: 50%;\n\n    background: var(--mint);\n\n    top: -6px;\n    left: 50%;\n\n    transform: translateX(-50%);\n\n    box-shadow: 0 0 10px rgba(191, 241, 219, .7);\n\n}\n\n/* ---------------- TEXT ---------------- */\n\n.error-number {\n\n    font-size: 72px;\n\n    font-weight: 800;\n\n    letter-spacing: 4px;\n\n    margin-top: 10px;\n\n    margin-bottom: 10px;\n\n    color: #6b63d9;\n\n}\n\n.notfound-card h1 {\n\n    font-size: 34px;\n\n    font-weight: 700;\n\n    color: #394150;\n\n    margin-bottom: 18px;\n\n}\n\n.notfound-card p {\n\n    line-height: 1.8;\n\n    color: #667085;\n\n    margin-bottom: 35px;\n\n}\n\n/* ---------------- BUTTONS ---------------- */\n\n.button-row {\n\n    display: flex;\n    justify-content: center;\n    gap: 18px;\n\n}\n\n.action-btn {\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    padding: 12px 24px;\n\n    font-weight: 600;\n\n    border-radius: 14px;\n\n    transition: .25s;\n\n}\n\n.home-btn {\n\n    background: var(--lavender);\n\n    border: none;\n\n}\n\n.home-btn:hover {\n\n    background: #c7c3fc;\n\n    transform: translateY(-2px);\n\n}\n\n.btn-light {\n\n    border: 1px solid #ddd;\n\n}\n\n.btn-light:hover {\n\n    background: #fafafa;\n\n    transform: translateY(-2px);\n\n}\n\n/* ---------------- ANIMATIONS ---------------- */\n\n@keyframes spin {\n\n    from {\n\n        transform: rotate(0deg);\n\n    }\n\n    to {\n\n        transform: rotate(360deg);\n\n    }\n\n}\n\n@keyframes spinReverse {\n\n    from {\n\n        transform: rotate(360deg);\n\n    }\n\n    to {\n\n        transform: rotate(0deg);\n\n    }\n\n}\n\n@keyframes bounce {\n\n    0%,\n    100% {\n\n        transform: translateY(0);\n\n    }\n\n    50% {\n\n        transform: translateY(-10px);\n\n    }\n\n}\n\n/* ---------------- MOBILE ---------------- */\n\n@media(max-width:768px) {\n\n    .notfound-card {\n\n        width: 90%;\n\n        padding: 40px 28px;\n\n    }\n\n    .error-number {\n\n        font-size: 56px;\n\n    }\n\n    .button-row {\n\n        flex-direction: column;\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
